/** Reusable button that asks for confirmation before running a destructive action. */
import type { ButtonHTMLAttributes } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> { message: string }
export function ConfirmButton({ message, onClick, ...props }: Props) {
  return <button {...props} onClick={(event) => {
    if (window.confirm(message)) onClick?.(event);
  }} />;
}
